import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import { renderRoutes } from 'react-router-config';
import { SnackbarProvider } from 'notistack';

function App({ route }) {
  return (
    <CssBaseline>
      {/* here we need to render App's routes */}
      <SnackbarProvider maxSnack={5}>
        { renderRoutes(route.routes) }
      </SnackbarProvider>
    </CssBaseline>
  );
}

export default App;
